import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const VideoSound: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.973 1.5H7A4.5 4.5 0 0 1 7 10.447a.474.474 0 0 1-.5-.447v-.06a.5.5 0 0 1 .465-.499L7 9.438a3.5 3.5 0 0 0 0-6.93l-.035-.002a.5.5 0 0 1-.465-.499v-.034c0-.261.212-.473.473-.473m-1.74.616c.409-.343.738-.209.765.288L6 2.471v7.005c0 .528-.315.696-.715.397l-.052-.042-2.304-1.93H1.497a.5.5 0 0 1-.494-.445L1 7.398V4.549a.5.5 0 0 1 .439-.5l.058-.004h1.432zM7.44 4.032l.028.001.031.003a2 2 0 0 1 .095 3.847l-.099.028a.44.44 0 0 1-.493-.383l-.002-.027L7 4.473a.44.44 0 0 1 .44-.44"
        clipRule="evenodd"
      />
    </svg>
  </IconWrap>
);

VideoSound.displayName = 'VideoSound';
export default VideoSound;
